module.exports = "\n.ng-valid[required], .ng-valid.required  {\n    border-left: 5px solid #42A948;\n  }\n  \n  .ng-invalid:not(form)  {\n    border-left: 5px solid #a94442;\n  }\n  \n  .alert{\n    margin-top:10px;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/publicaciones/editarpub/editarpub.component.css
// module id = ./src/app/publicaciones/editarpub/editarpub.component.css
// module chunks = main